class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      if (cartItems && this.dataset.index) {
        try {
          cartItems.updateQuantity(this.dataset.index, 0);
        } catch (error) {
          console.error('Error removing cart item:', error);
        }
      } else {
        console.warn('Cart items element or index not found');
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    this.minicartSelector = '.drawer__inner';
    this.addEventListener('change', debouncedOnChange.bind(this));
    this.initializeCartCheck();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  initializeCartCheck() {
    setTimeout(() => {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then((response) => response.json())
        .then((data) => {
          // Get Cash On Delivery vendor from shop settings or use default
          const codVendor = window.shopSettings?.cod_product_vendor || 'Additional service';
          const additionalServiceItems = data.items.filter((item) => item.vendor == codVendor);

          // Check if there is COD product in the cart and remove it if its the only item
          if (additionalServiceItems.length > 0) {
            if (additionalServiceItems.length === data.item_count) {
              if (document.querySelector('cart-items')) {
                document.querySelector('cart-items').cartClear();
              } else {
                this.cartClear();
              }
            }
          }
        });
    }, 300);
  }

  cartClear() {
    let section = this.getSectionsToRender().map((section) => section.section);

    let data = {
      sections: section,
      updates: {},
    };

    fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((response) => {
        setTimeout(() => {
          this.renderContents(response);
        }, 100);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    });
  }

  onChange(event) {
    if (!event.target.dataset.index || !event.target.value) {
      console.warn('Missing required data for cart update:', event.target.dataset);
      return;
    }

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement?.getAttribute('name') || '',
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__totals'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    const headerElement = document.querySelector('[id$=header]');

    return [
      {
        id: 'main-cart',
        section: document.getElementById('main-cart')?.dataset?.id || 'main-cart',
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'CartDrawer',
        section: document.getElementById('CartDrawer')?.dataset?.id || 'CartDrawer',
        selector: this.minicartSelector,
      },
      {
        id: headerElement?.id || 'header',
        section: 'header',
        selector: '#cart-icon-bubble',
      },
    ];
  }
  getDrawerLightRenderSelectors() {
    return [
      '.drawer__header',
      '.cart__free-shipping-progress',
      '.cart-drawer__hold-in-bag',
      '.drawer__contents.js-contents',
      '.cart-drawer__totals',
      '.extra-services--minicart',
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    const cartItemsObj = this;
    this.enableLoading(line);

    let sectionsToRender;
    if (location.pathname.includes('cart')) {
      let cartItems = document.querySelector('cart-items');
      sectionsToRender = cartItems?.getSectionsToRender();
    } else {
      sectionsToRender = this.getSectionsToRender();
    }

    let errors;
    let isMaxQuantityError = false;

    // Handle both cart page and cart drawer line items
    const cartLineItem = document.getElementById(`CartItem-${line}`);
    const cartDrawerLineItem = document.getElementById(`CartDrawer-Item-${line}`);
    const lineItem = cartLineItem || cartDrawerLineItem;

    // Handle both cart page and cart drawer quantity elements
    const cartQuantityElement = document.getElementById(`Quantity-${line}`);
    const cartDrawerQuantityElement = document.getElementById(`Drawer-quantity-${line}`);
    const quantityElement = cartQuantityElement || cartDrawerQuantityElement;

    const body = JSON.stringify({
      line,
      quantity: parseInt(quantity),
      sections: sectionsToRender.map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        if (!response.ok) {
          return response.text().then((text) => {
            console.error('Cart update error response:', text);
            throw new Error(`HTTP error! status: ${response.status} - ${text}`);
          });
        }
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          errors = parsedState.errors;
          // Reset quantity values for both cart page and cart drawer
          if (cartQuantityElement) {
            cartQuantityElement.value = cartQuantityElement.getAttribute('value');
          }
          if (cartDrawerQuantityElement) {
            cartDrawerQuantityElement.value = cartDrawerQuantityElement.getAttribute('value');
          }
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        // Filter out service items from parsedState.items
        const nonServiceItems = parsedState.items.filter((item) => item.product_type !== 'Extra services');

        this.classList.toggle('is-empty', nonServiceItems.length === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', nonServiceItems.length === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', nonServiceItems.length === 0);

        if (nonServiceItems.length === 0) {
          this.cartClear();
        }

        sectionsToRender.forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

          if (!elementToReplace) return;
          if (nonServiceItems.length > 0 && section.selector === cartItemsObj.minicartSelector) {
            // light redraw of the minicart - only update specific sections
            cartItemsObj.getDrawerLightRenderSelectors().forEach((drawerSubsectionSelector) => {
              const sectionElement = elementToReplace.querySelector(drawerSubsectionSelector);
              if (sectionElement) {
                sectionElement.innerHTML = this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  drawerSubsectionSelector
                );
              }
            });
          } else {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        if (window.updateWishlistStateImmediately) {
          window.updateWishlistStateImmediately();
        }

        // Re-attach event listeners to cart drawer after content update
        if (cartDrawerWrapper) {
          cartDrawerWrapper.reattachEventListeners();
        }

        let message = '';
        if (quantity > 0 && parsedState.items && parsedState.items.length > 0) {
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          if (
            items.length === parsedState.items.length &&
            updatedValue !== undefined &&
            quantityElement &&
            parseInt(quantityElement.value) !== updatedValue
          ) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings?.error || 'Error updating quantity';
            } else {
              message =
                window.cartStrings?.quantityError?.replace('[quantity]', updatedValue) ||
                `Quantity updated to ${updatedValue}`;
            }
          }
        }

        this.updateLiveRegions(line, message);

        // Handle focus management for both cart page and cart drawer
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          const focusElement = lineItem.querySelector(`[name="${name}"]`);
          if (cartDrawerWrapper && cartDrawerLineItem) {
            // Focus within cart drawer
            trapFocus(cartDrawerWrapper, focusElement);
          } else if (cartLineItem) {
            // Focus within cart page
            focusElement.focus();
          }
        } else if (nonServiceItems.length === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch((e) => {
        if (quantity === 0) {
          this.onCartUpdate();
        }

        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));

        // Handle error display for both cart page and cart drawer
        const cartErrors = document.getElementById('cart-errors');
        const cartDrawerErrors = document.getElementById('CartDrawer-CartErrors');
        const errors = cartErrors || cartDrawerErrors;

        const maxQuantity = quantityElement?.getAttribute('max') || quantityElement?.dataset.cartQuantity;

        if (maxQuantity && parseInt(quantity) > parseInt(maxQuantity)) {
          isMaxQuantityError = true;
          const errorMessage = window.cartStrings?.quantityErrorAlert?.replace('[quantity]', quantity);
          if (errorMessage) {
            this.updateLiveRegions(line, errorMessage);
          }
          // Reset quantity values for both cart page and cart drawer
          if (cartQuantityElement) {
            cartQuantityElement.value = cartQuantityElement.getAttribute('value');
          }
          if (cartDrawerQuantityElement) {
            cartDrawerQuantityElement.value = cartDrawerQuantityElement.getAttribute('value');
          }
        } else if (errors) {
          errors.textContent = window.cartStrings?.error || 'Error updating cart';
        }
      })
      .finally(() => {
        this.disableLoading(line);

        if (!this.classList.contains('main-cart-items')) {
          return;
        }

        if (this.classList.contains('is-empty')) {
          return;
        }

        if (isMaxQuantityError) {
          return;
        }

        let notificationType;
        let string;

        if (quantity > 0 && lineItem?.dataset.lineTitle != undefined) {
          !errors ? (notificationType = 'success') : (notificationType = 'alert');

          if (!errors) {
            string = this.createNotificationString(
              window.cartActions?.item_quantity_changed_html,
              lineItem?.dataset.lineTitle,
              quantity
            );
          } else {
            string = errors;
          }
        } else {
          string = this.createNotificationString(
            window.cartActions?.item_removed_html,
            lineItem?.dataset?.lineTitle ?? '',
            quantity
          );
        }

        const tagToFind = window.extraServices?.low_order_value_service_fee_product;

        const link = lineItem?.querySelector('a');
        const hasTag = link && link.href && link.href.includes(tagToFind);

        if (hasTag) {
          notificationType = 'success';
        } else {
          notificationType = 'warning';
        }

        this.createNotification(notificationType, string);
      });
  }

  updateLiveRegions(line, message) {
    if (!message) return;

    const phoneValidationErrorMessage = this.decodeHtmlEntities(
      window.cartStrings?.validation?.phone?.errorMessage || ''
    );
    let isPhoneValidation = false;

    if (phoneValidationErrorMessage) {
      const regex = /\(([^)]+)\)/g;
      const messageHasPhone = message.match(regex);
      if (messageHasPhone) {
        const messagePhoneTranslation = phoneValidationErrorMessage.replace('[[phone]]', messageHasPhone[0]);
        if (message === messagePhoneTranslation) {
          isPhoneValidation = true;
        }
      }
    }

    // Handle line item errors for both cart page and cart drawer
    const lineItemError = document.getElementById(`Line-item-error-${line}`);
    const cartDrawerLineItemError = document.getElementById(`CartDrawer-LineItemError-${line}`);

    if ((lineItemError || cartDrawerLineItemError) && !isPhoneValidation) {
      // Update cart page error if it exists
      if (lineItemError) {
        const errorTextElement = lineItemError.querySelector('.cart-item__error-text');
        if (errorTextElement) {
          errorTextElement.innerHTML = message;
        }
      }

      // Update cart drawer error if it exists
      if (cartDrawerLineItemError) {
        const cartDrawerErrorTextElement = cartDrawerLineItemError.querySelector('.cart-item__error-text');
        if (cartDrawerErrorTextElement) {
          cartDrawerErrorTextElement.innerHTML = message;
        }
      }
    }

    // Handle line item status elements for both cart page and cart drawer
    const cartLineItemStatus = document.getElementById('shopping-cart-line-item-status');
    const cartDrawerLineItemStatus = document.getElementById('CartDrawer-LineItemStatus');

    if (cartLineItemStatus) {
      cartLineItemStatus.setAttribute('aria-hidden', true);
    }
    if (cartDrawerLineItemStatus) {
      cartDrawerLineItemStatus.setAttribute('aria-hidden', true);
    }

    // Handle live region text for both cart page and cart drawer
    const cartLiveRegionText = document.getElementById('cart-live-region-text');
    const cartDrawerLiveRegionText = document.getElementById('CartDrawer-LiveRegionText');

    // Update both live region texts if they exist
    if (cartLiveRegionText) {
      cartLiveRegionText.setAttribute('aria-hidden', false);
      cartLiveRegionText.textContent = message;

      setTimeout(() => {
        cartLiveRegionText.setAttribute('aria-hidden', true);
      }, 1000);
    }

    if (cartDrawerLiveRegionText) {
      cartDrawerLiveRegionText.setAttribute('aria-hidden', false);
      cartDrawerLiveRegionText.textContent = message;

      setTimeout(() => {
        cartDrawerLiveRegionText.setAttribute('aria-hidden', true);
      }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    // Handle both cart page and cart drawer containers
    const mainCartItems = document.getElementById('main-cart-items');
    const cartDrawerItems = document.getElementById('CartDrawer-CartItems');

    if (mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
    }
    if (cartDrawerItems) {
      cartDrawerItems.classList.add('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();

    // Handle line item status for both cart page and cart drawer
    const cartLineItemStatus = document.getElementById('shopping-cart-line-item-status');
    const cartDrawerLineItemStatus = document.getElementById('CartDrawer-LineItemStatus');

    if (cartLineItemStatus) {
      cartLineItemStatus.setAttribute('aria-hidden', false);
    }
    if (cartDrawerLineItemStatus) {
      cartDrawerLineItemStatus.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    // Handle both cart page and cart drawer containers
    const mainCartItems = document.getElementById('main-cart-items');
    const cartDrawerItems = document.getElementById('CartDrawer-CartItems');

    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }
    if (cartDrawerItems) {
      cartDrawerItems.classList.remove('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  createNotificationString(string, title, quantity) {
    return `${string.replace('{{ title }}', title).replace('{{ value }}', quantity)}`;
  }

  createNotification(type, string) {
    let actionsElm = document.getElementById('cart-actions');
    if (!actionsElm) return;

    let notificationClass = actionsElm?.dataset?.notificationClass;
    let notificationSuccessClass = actionsElm?.dataset?.notificationSuccessClass;
    let notificationWarningClass = actionsElm?.dataset?.notificationWarningClass;
    let notificationAlertClass = actionsElm?.dataset?.notificationAlertClass;
    // ['success', 'warning', 'alert']
    let notification = document.createElement('div');
    notification.classList.add('text-x-small');

    if (type === 'success' && notificationClass && notificationSuccessClass) {
      notification.classList.add(notificationClass, notificationSuccessClass);
    } else if (type === 'warning' && notificationClass && notificationWarningClass) {
      notification.classList.add(notificationClass, notificationWarningClass);
    } else if (type === 'alert' && notificationClass && notificationAlertClass) {
      notification.classList.add(notificationClass, notificationAlertClass);
    }

    pushNotification(actionsElm, notification, string);

    function pushNotification(parent, child, string) {
      if (child && string) {
        child.innerHTML = string;
        parent?.prepend(child);
      }
    }
  }

  decodeHtmlEntities(text) {
    const doc = new DOMParser().parseFromString(text, 'text/html');
    return doc.documentElement.textContent;
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
